import { createFileRoute } from '@tanstack/react-router'
import { Pagamentos } from '@/features/portal/pagamentos'
import { PortalShell } from '@/features/portal/shell'

/** Cobranças do paciente: PIX em aberto e o que já foi pago. */
export const Route = createFileRoute('/_portal/portal_/pagamentos')({
  component: function PagamentosDoPortal() {
    return (
      <PortalShell title="Pagamentos">
        <Pagamentos />
      </PortalShell>
    )
  },
})
